<template>
  <div class="admin__container overflow-hidden py-5 px-lg-5" :id="userRequest._id">
    <div class="relative admin__container__main shadow rounded-lg">
      <div class="details__container">
        <div class="details__picture">
          <img v-if="userRequest.data.profilePictureUrl" class=""
            :src="`${constants.s3Bucket}/editor/profile-pictures/${reviewAssignment.users[currentSelectedUserIndex].userData.profilePictureUrl}`"
            alt="Profile Picture" />

          <img v-else class="" :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
            userRequest.data.firstName || 'boringAvatar',
            userRequest.data.lastName || 'boringAvatar'
          )}`" alt="Profile Picture" />

          <!-- <span class="__role">To Review</span> -->
        </div>

        <div class="details__information">
          <div class="main__info">
            <h3 class="flex items-center flex-wrap">
              {{ userRequest.data.firstName }}
              {{ userRequest.data.lastName }}

              <span class="extra__text flex flex-wra ml-2 items-center">
                to join

                <vs-select class="rounded-3xl ml-2" placeholder="Board Name" v-model="selectedBoard">
                  <vs-select-item v-for="(type, index) in boardsData" :key="index" :value="type.value"
                    :text="type.text" />
                </vs-select>
              </span>
            </h3>
            <h6>
              {{ userRequest.data.profession }}
            </h6>
          </div>

          <!-- <div class="skills__info">
              <h6>Skill</h6>

              <div>
                <span>Figma</span>
                <span>Adobe Illustrator </span>
                <span>Office 365</span>
              </div>
            </div> -->

          <div class="contact__info">
            <div class="contact__details">
              <img src="@/assets/images/icons/org-review/iconEmail.svg" alt="email" />

              <div>
                {{ userRequest.data.email }}
              </div>
            </div>

            <!-- <div class="contact__details">
                <img
                  :src="
                    require(`@/assets/images/icons/org-review/iconPhone.svg`)
                  "
                  alt="phone"
                />

                <a>+12 345 6789 0</a>
              </div> -->
          </div>
        </div>
      </div>

      <div class="flex items-end justify-end">
        <div class="button__decline px-3 py-2 mr-3 flex items-center cursor-pointer"
          @click="updateRequestStatus(userRequest, 'DECLINED', index)">
          <img class="mr-2" src="@/assets/images/icons/org-review/cross.svg" alt="" />
          Decline
        </div>
        <div class="button__accept px-3 py-2 flex items-center cursor-pointer"
          :class="selectedBoard ? '' : 'opacity-75 pointer-events-none'"
          @click="updateRequestStatus(userRequest, 'ACCEPTED', index)">
          <img class="mr-2" src="@/assets/images/icons/org-review/tick.svg" alt="" />

          Accept
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedBoard: "",
    };
  },
  props: {
    userRequest: {
      type: Object,
      required: true,
    },
    boardsData: {
      type: Array,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  computed: {
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },
  },
  methods: {
    updateRequestStatus(user, status) {
      this.$emit(
        "updateRequestStatus",
        user,
        status,
        this.index,
        this.selectedBoard
      );
    },
  },
};
</script>

<style lang="scss">
.admin__container {
  display: grid;
  place-content: center;
  justify-content: center;
  align-items: center;
  grid-template-columns: repeat(1, minmax(0, 1fr));

  &__main {
    display: grid;
    place-content: center;
    justify-content: space-between;
    grid-auto-flow: column;
    grid-column: span 1 / span 1;
    padding: 2em 2em;
    background-color: white;
    gap: 2em;
    // background-image: url("../../../../assets/images/icons/org-review/admin__background.png");
    background-size: 100% 100%;
    background-position: right;
    background-repeat: no-repeat;

    .details__container {
      display: grid;
      place-content: start;
      grid-auto-flow: column;

      .details__picture {
        display: grid;
        position: relative;
        place-content: center;
        height: fit-content;
        place-self: start;
        grid-column: span 1 / span 1;
        width: fit-content;
        margin-right: 2em;

        .__img {
          padding: 0.5em;
          width: 10em;
          height: 10em;
          border: 3px solid #12b76a;
          border-radius: 50%;
        }

        .__role {
          padding: 0.5em 1em;
          width: fit-content;
          text-align: center;
          background-color: #12b76a;
          color: white;
          font-weight: 600;
          position: absolute;
          place-self: center;
          bottom: -0.8em;
          border: 5px solid white;
          border-radius: 5em;
        }
      }

      .details__information {
        display: grid;
        place-content: start;
        height: fit-content;
        // gap: 1em 0em;
        grid-column: span 3 / span 3;
        grid-template-columns: repeat(1, minmax(0, 1fr));

        .main__info {
          display: grid;
          place-content: start;
          grid-column: span 1 / span 1;

          h3 {
            color: #202020;
            font-size: 1.5em;
            font-weight: 700;
          }

          h6 {
            font-size: 1.1em;
            font-weight: 400;
            color: #a5a5a5;
          }
        }

        .skills__info {
          display: grid;
          grid-auto-flow: column;
          gap: 1em;
          margin-top: 0.5em;
          place-content: start;
          align-items: start;
          justify-content: flex-start;
          grid-column: span 1 / span 1;

          h6 {
            font-size: 1.1em;
            font-weight: 500;
            color: #91919f;
            padding-top: 0.15em;
          }

          div {
            display: flex;
            gap: 0.8em;
            place-content: center;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: flex-start;
            justify-content: flex-start;
            width: 100%;

            span {
              font-size: 0.9em;
              font-weight: 600;
              text-align: center;
              color: #f29300;
              padding: 0.3em 1em;
              border-radius: 3em;
              background-color: #f292001a;
              white-space: nowrap;
              width: fit-content;
              place-self: start;
            }
          }
        }

        .contact__info {
          display: grid;
          grid-auto-flow: column;
          place-content: start;
          width: 100%;
          gap: 3em;

          .contact__details {
            display: grid;
            grid-auto-flow: column;
            margin-top: 3.5em;
            align-items: center;
            place-content: start;
            gap: 0.8em;

            img {
              width: 2.5em;
            }

            a {
              white-space: nowrap;
              text-decoration: none;
              font-size: 1em;
              font-weight: 500;
            }
          }
        }
      }
    }

    .treasury__container {
      display: grid;
      justify-content: end;
      gap: 1em;

      h3 {
        font-size: 1.7em;
        font-weight: 600;
        text-align: left;
        color: #000000;
        place-self: start;
        justify-self: start;
      }

      h4 {
        font-size: 1.3em;
        font-weight: 600;
        color: #000000;
        text-align: left;
        margin-top: 3em;
      }

      .treasury__information {
        display: grid;
        place-content: start;
        grid-auto-flow: column;
        gap: 5em;
        place-self: end;
        justify-content: end;

        &__1 {
          display: grid;

          h6 {
            font-size: 0.8em;
            font-weight: 500;
            text-align: left;
            color: #667085;
            white-space: nowrap;
          }

          h5 {
            font-size: 1em;
            font-weight: 600;
            text-align: left;
            color: #101828;
          }
        }

        &__2 {
          display: grid;

          h6 {
            font-size: 0.8em;
            font-weight: 500;
            text-align: right;
            color: #667085;
            white-space: nowrap;
          }

          h5 {
            font-size: 1em;
            font-weight: 600;
            text-align: right;
            color: #101828;
          }
        }
      }
    }
  }
}

.button {
  &__accept {
    background: #25cc9a;

    color: #fff;
    border-radius: 2em;
    font-weight: 900;
    font-size: 1.2em;
  }

  &__decline {
    background: #ff6584;

    color: #fff;
    border-radius: 2em;
    font-weight: 900;
    font-size: 1.2em;
  }
}

@media only screen and (max-width: 768px) {
  .admin__container {
    &__main {
      grid-auto-flow: row;
      gap: 3em;
      width: fit-content;
      place-self: center;
      place-content: center;
      justify-content: center;
      display: grid;
      background-size: 100% auto;
      background-position: right bottom;

      .details__container {
        grid-auto-flow: row;
        gap: 3em;
      }

      .details__container {
        .details__information {
          .contact__info {
            grid-auto-flow: row;
            gap: 0em;
            margin-top: 0;

            .contact__details {
              margin-top: 2em;
              place-content: start;
            }
          }
        }
      }

      .treasury__container {
        justify-self: center;
        align-self: center;
        place-content: start;
        width: 100%;
      }
    }
  }
}

@media only screen and (max-width: 450px) {
  .admin__container {
    &__main {
      .details__container {
        .details__information {
          .contact__info {
            grid-auto-flow: row;
            gap: 0em;
            margin-top: 0;

            .contact__details {
              margin-top: 2em;
              place-content: start;
            }
          }
        }
      }
    }
  }
}
</style>
